module.exports = __webpack_public_path__ + "static/media/9DESA36.fbbe9414.jpg";